import { z } from '@repo/schema'
import { GetAddressSchema } from '@repo/schema/address'
import { GetCompanyAccountSchema } from '@repo/schema/company'
import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import {
  addPhoneWithCountryValidation,
  createPhoneNumberFieldSchema,
  OptionalPhoneCountryCodeSchema,
} from '@repo/schema/phone'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure'

export const createShippersRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)
  const phoneInputSchema = z.object({
    phone: createPhoneNumberFieldSchema().optional(),
    phone_country: OptionalPhoneCountryCodeSchema.optional(),
  })
  const accountInputSchema = z
    .object({
      phone: createPhoneNumberFieldSchema().nullish(),
      phone_country: OptionalPhoneCountryCodeSchema.nullish(),
    })
    .partial()
    .passthrough()
    .superRefine((data, ctx) => {
      addPhoneWithCountryValidation(ctx, data.phone, data.phone_country)
    })

  return {
    account: {
      get: p
        .path(z.object({ id: z.number() }), p => ['companies', p.id, 'account'])
        .input(z.object({ id: z.number() }))
        .query(({ input, path, upFetch }) =>
          upFetch(path, {
            schema: getDataWrapperSchema(GetCompanyAccountSchema).transform(company => ({
              ...company,
              id: input.id,
            })),
          }),
        ),
      update: p
        .path(z.object({ id: z.number() }), p => ['companies', p.id, 'account'])
        .input(accountInputSchema)
        .mutation(({ input, path, upFetch }) =>
          upFetch(path, {
            body: input,
            method: 'PATCH',
          }),
        ),
    },
    company: {
      update: p
        .path('shippers', 'company')
        .input(
          phoneInputSchema
            .extend({
              address: GetAddressSchema.pick({
                city: true,
                country: true,
                place_name: true,
                postcode: true,
              }).optional(),
              email: z.email().optional(),
              registration_number: z.string().optional(),
              source: z.enum(['kcharles', 'cargoking', 'cargoking-shipper']),
              title: z.string(),
              type: z.enum(['haulier', 'shipper']),
              vat: z.string().optional(),
            })
            .superRefine((data, ctx) => {
              addPhoneWithCountryValidation(ctx, data.phone, data.phone_country)
            }),
        )
        .mutation(({ input, path, upFetch }) =>
          upFetch(path, {
            body: input,
            method: 'POST',
          }),
        ),
    },
    update: p
      .path(z.object({ company: z.object({ id: z.number() }) }), ({ company }) => [
        'companies',
        'shippers',
        company.id,
      ])
      .input(z.record(z.string(), z.unknown()))
      .mutation(({ input, path, upFetch }) =>
        upFetch(path, {
          body: input,
          method: 'PATCH',
        }),
      ),
  }
}
